import { Route, Routes } from "react-router-dom";
import AppShell from "../components/layout/AppShell";
import { LOCALES } from "../i18n/messages";
import AuctionPage from "../pages/AuctionPage";
import AuctionDetailPage from "../pages/AuctionDetailPage";
import BlogListPage from "../pages/BlogListPage";
import BlogPostPage from "../pages/BlogPostPage";
import DetailPage from "../pages/DetailPage";
import ForbiddenPage from "../pages/ForbiddenPage";
import HomePage from "../pages/HomePage";
import MarketPage from "../pages/MarketPage";
import NotFoundPage from "../pages/NotFoundPage";
import ProfilePage from "../pages/ProfilePage";
import RwaPage from "../pages/RwaPage";
import SettlementPage from "../pages/SettlementPage";
import StudioPage from "../pages/StudioPage";

const PAGE_CONFIG = [
  { pageKey: "home", navKey: "home", slug: "", component: HomePage },
  { pageKey: "auction", navKey: "auction", slug: "auction", component: AuctionPage },
  { pageKey: "auctionDetail", navKey: "auction", slug: "auction/:auctionId", component: AuctionDetailPage },
  { pageKey: "market", navKey: "market", slug: "market", component: MarketPage },
  { pageKey: "detail", navKey: "detail", slug: "detail", component: DetailPage },
  { pageKey: "rwa", navKey: "rwa", slug: "rwa", component: RwaPage },
  { pageKey: "settlement", navKey: "settlement", slug: "settlement", component: SettlementPage },
  { pageKey: "profile", navKey: "profile", slug: "profile", component: ProfilePage },
  { pageKey: "studio", navKey: "studio", slug: "studio", component: StudioPage },
  { pageKey: "blog", navKey: "blog", slug: "blog", component: BlogListPage },
  { pageKey: "blogPost", navKey: "blog", slug: "blog/:postId", component: BlogPostPage },
  { pageKey: "forbidden", navKey: "", slug: "forbidden", component: ForbiddenPage },
];

function localizedPath(prefix, slug) {
  if (!prefix) {
    if (!slug) return "/";
    return `/${slug}`;
  }
  if (!slug) return `/${prefix}`;
  return `/${prefix}/${slug}`;
}

export default function AppRoutes() {
  const localeEntries = Object.entries(LOCALES);

  return (
    <Routes>
      {localeEntries.flatMap(([locale, info]) =>
        PAGE_CONFIG.map((page) => {
          const PageComponent = page.component;
          return (
            <Route
              key={`${locale}-${page.slug || "home"}`}
              path={localizedPath(info.prefix, page.slug)}
              element={
                <AppShell locale={locale} pageKey={page.navKey}>
                  <PageComponent locale={locale} />
                </AppShell>
              }
            />
          );
        }),
      )}
      <Route
        path="*"
        element={
          <AppShell locale="zh-Hans" pageKey="">
            <NotFoundPage />
          </AppShell>
        }
      />
    </Routes>
  );
}
